module.exports = __webpack_public_path__ + "img/82.e582a4df.jpg";